import { Capacitor, registerPlugin } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { NATIVE_OAUTH_REDIRECT_URI } from './nativeAuth';

interface SignInBrowserPlugin {
  isChromeOs(): Promise<{ value: boolean }>;
  openExternal(options: { url: string }): Promise<void>;
}

const SignInBrowser = registerPlugin<SignInBrowserPlugin>('SignInBrowser');

async function isChromeOs(): Promise<boolean> {
  try {
    return (await SignInBrowser.isChromeOs()).value;
  } catch {
    return false;
  }
}

// Set per environment by scripts/deploy.ps1; dev values are the local/mobile fallback.
const COGNITO_DOMAIN =
  process.env.REACT_APP_COGNITO_DOMAIN || 'hunttimer-dev.auth.us-east-1.amazoncognito.com';
const CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID || '13vu7r6ur7jjqe0ipfn1k8qfef';

/** Starts the Cognito-hosted Google sign-in. New Google users are created automatically. */
export async function startGoogleSignIn(): Promise<void> {
  const callbackUrl = Capacitor.isNativePlatform()
    ? NATIVE_OAUTH_REDIRECT_URI
    : `${window.location.origin}/auth/callback`;
  const url = `https://${COGNITO_DOMAIN}/oauth2/authorize?identity_provider=Google&response_type=code&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(callbackUrl)}&scope=openid+email`;

  if (Capacitor.isNativePlatform()) {
    // Chrome Custom Tabs can open a blank window on ChromeOS, so use the system browser there.
    if (await isChromeOs()) {
      await SignInBrowser.openExternal({ url });
    } else {
      await Browser.open({ url });
    }
  } else {
    window.location.href = url;
  }
}
